
  import Vue from "vue";
  import {ROULETTE_PRIZE_TYPE_ID} from "@/utils/roluette-prizes";
  import {CurrencyType} from "@/utils/common";

  export default Vue.extend({
    name: "pwa-roulette-success-modal",
    props: {
      prize: {
        type: Object,
        required: true,
      },
    },
    computed: {
      prizeMessage(): string {
        let message = '';
        if (this.prize.roulette_prize_type_id === ROULETTE_PRIZE_TYPE_ID.NO_PRIZE) {
          message = this.$t('666');
        } else {
          let prize = '';
          if (this.prize.roulette_prize_type_id === ROULETTE_PRIZE_TYPE_ID.COIN) {
            prize = this.formatPrice(this.prize.amount, !this.currency.icon, this.currency.decimals, true);
            if (this.currency.icon) {
              prize += ` <img class="pwa-currency-icon" src="${this.getBrandImageSrc(this.currency.icon + '.svg')}" alt="${this.currency.icon}" style="height: 16px;" />`;
            }
          } else {
            prize = this.prize.title.replace('\\n', ' ');
          }

          message = this.$t('667', {prize});
        }

        return message;
      },
      currency(): CurrencyType {
        return this.$store.state.app.config.currency;
      },
    },
  });
